module.exports = __webpack_public_path__ + "img/glassquality_4.dc61cc1d.png";